import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-55e5c2b2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "appeal-content" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  key: 0,
  class: "message-text"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = {
  key: 3,
  class: "success-message"
}
const _hoisted_8 = { key: 4 }
const _hoisted_9 = { class: "name" }
const _hoisted_10 = { class: "appeal-description" }
const _hoisted_11 = { class: "question" }

import {onMounted, ref} from "vue";
import config from "@/config.json";
import {loginUrl} from "@/utils/LoginUrl";
import i18n from "@/plugins/i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'AppealView',
  setup(__props) {

if(!localStorage.getItem('token')) window.location.replace(loginUrl());

let loading = ref(true)
let valid = ref(true)
let submitting = ref(false)
let message = ref('')
let questions = ref({})
let answers = ref(Array(4).fill(''))

const answerRules = [
  (answer: string) => ((answer.length > 0 && answer.length <= 500) || i18n.global.t('Appeal.errors.invalidAnswer'))
]

onMounted(async () => {
  let response = await fetch(`${config.API}/private/support/appeal`, {
    headers: {
      Authorization: localStorage.getItem('token') as string
    }
  })
  let body = await response.json()
  if (!response.ok) message.value = body.message
  else questions.value = body.questions
  loading.value = false
})

async function submit() {
  submitting.value = true
  console.log(answers.value)
  let response = await fetch(`${config.API}/private/support/appeal`,
      {
        method: 'POST',
        headers: {
          Authorization: localStorage.getItem('token') as string,
          'Content-Type': 'application/json'
        }, body: JSON.stringify({
          answers: answers.value
        })
      })
  let body = await response.json()
  message.value = body.message
  submitting.value = false
}

return (_ctx: any,_cache: any) => {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(loading))
      ? (_openBlock(), _createBlock(_component_v_progress_circular, {
          key: 0,
          class: "item-center",
          size: "60",
          width: "5",
          indeterminate: ""
        }))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_unref(message).length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (_unref(message).includes('not banned'))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.$t('Appeal.errors.notBanned')), 1))
                  : (_unref(message).includes('been submitted'))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.$t('Appeal.errors.submitted')), 1))
                    : (_unref(message).includes('been declined'))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.$t('Appeal.errors.declined')), 1))
                      : (_unref(message).includes('successfully'))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.$t('Appeal.submitted')), 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.$t('Appeal.errors.submitError')), 1))
              ]))
            : (_openBlock(), _createBlock(_component_v_form, {
                key: 1,
                modelValue: _unref(valid),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(valid) ? (valid).value = $event : valid = $event)),
                class: "questions"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('Appeal.name')), 1),
                  _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('Appeal.description')), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(questions)[_ctx.$i18n.locale], (question, i) => {
                    return (_openBlock(), _createElementBlock("div", null, [
                      _createElementVNode("div", _hoisted_11, _toDisplayString(i+1) + ". " + _toDisplayString(question), 1),
                      _createVNode(_component_v_textarea, {
                        modelValue: _unref(answers)[i],
                        "onUpdate:modelValue": ($event: any) => ((_unref(answers)[i]) = $event),
                        label: _ctx.$t('Appeal.answer'),
                        color: "primary",
                        rules: answerRules,
                        counter: 500
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "label"])
                    ]))
                  }), 256)),
                  _createVNode(_component_v_btn, {
                    class: "submit",
                    disabled: _unref(valid) === false || !_unref(answers).find(a => a.trim().length),
                    size: "large",
                    color: "secondary",
                    loading: _unref(submitting),
                    onClick: submit
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, { class: "save-icon" }, {
                        default: _withCtx(() => [
                          _createTextVNode("mail_outline")
                        ]),
                        _: 1
                      }),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('Appeal.submit')), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled", "loading"])
                ]),
                _: 1
              }, 8, ["modelValue"]))
        ]))
  ]))
}
}

})